import { useCallback } from 'react';

import { Apollo } from 'src/gql/generated';

/**
 * Sets user feedback (thumbs up/down) for an assistant message.
 */
export const useUpdateFeedback = () => {
  const [updateAgentMessageFeedback] = Apollo.useUpdateAgentMessageFeedbackMutation();
  const updateFeedback = useCallback(
    ({
      feedback,
      messageId,
    }: {
      feedback: Apollo.AgentMessageFeedback | null;
      messageId: string;
    }) => {
      return updateAgentMessageFeedback({
        optimisticResponse: {
          __typename: 'Mutation',
          updateAgentMessageFeedback: { __typename: 'AgentMessage', feedback, id: messageId },
        },
        variables: { input: { feedback, messageId } },
      });
    },
    [updateAgentMessageFeedback]
  );

  return { updateFeedback };
};
